<template>
    <div>
        <app-new-breadcrumb></app-new-breadcrumb>

        <div class="container-news">
            <h2 class="news-title">{{ $t("news") }}</h2>
            <div class="view-selector">
                <label for="viewSelector" class="selectLabel">{{ $t('selectView') }}</label>
                <select id="viewSelector" class="selectOptions" v-model="viewMode">
                    <option value="grid">{{ $t('gridView') }}</option>
                    <option value="list">{{ $t('listView') }}</option>
                </select>
            </div>
            <div class="item-list" :class="viewMode">
                <div v-for="item in displayedNews" :key="item.id" class="news-article" :class="viewMode">
                    <app-highlighted-news-card  v-if="viewMode === 'grid'" :id="item.id"></app-highlighted-news-card>
                    <app-highlighted-news-card-list  v-if="viewMode === 'list'" :id="item.id"></app-highlighted-news-card-list>
                </div>
            </div>
            <div v-if="viewMode === 'grid'" class="col-md-12 text-center">
                <app-paginate class="d-inline-flex mt-3" v-model="searchObject.currentPage"
                    v-bind:page-count="searchObject.numberOfPages" v-bind:click-handler="changePage"
                    v-bind:prev-text="$t('previous')" v-bind:next-text="$t('next')"
                    v-bind:container-class="'pagination'" v-bind:page-class="'page-item'"
                    v-bind:page-link-class="'page-link small'" v-bind:next-class="'page-item'"
                    v-bind:next-link-class="'page-link small'" v-bind:prev-class="'page-item'"
                    v-bind:prev-link-class="'page-link small'" v-bind:page-range="3" v-bind:margin-pages="1">
                </app-paginate>

            </div>
        </div>
    </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import HighlightedServicesCard from './HighlightedNewsCard.vue'
import HighlightedNewsCardList from './HighlightedNewsCardList.vue';
import Paginate from 'vuejs-paginate'
import Breadcrumb from "../common/Breadcrumb.vue";

export default {
    data() {
        return {
            htmlContent: "",
            allNews: [],
            viewMode: 'grid', 
            loading: false,
            searchObject: {
                currentPage: 1,
                pageSize: 4,
                numberOfPages: 1,
                totalRecords: 0
            },
        }
    },
    components: {
        appHighlightedNewsCard: HighlightedServicesCard,
        appHighlightedNewsCardList : HighlightedNewsCardList,
        appPaginate: Paginate,
        appNewBreadcrumb: Breadcrumb,
    },
    props: ["id"],
    computed: {
        ...mapGetters(["getAllNews", "getContentById", "getContentByUrl"]),
        hasHiglightedNews() {
            return this.getAllNews.length > 0;
        },
        displayedNews() {
            if (this.viewMode === 'list') {
                return this.getAllNews;  
            }
            const startIndex = (this.searchObject.currentPage - 1) * this.searchObject.pageSize;
            const endIndex = startIndex + this.searchObject.pageSize;
            return this.getAllNews.slice(startIndex, endIndex);  
        },
        isListView() {
            return this.viewMode === 'list';  
        },
    },
    methods: {
        ...mapActions(["fetchContentById"]),
        changePage(page) {
            this.searchObject.currentPage = page;
            this.updatePaginationInfo();
        },
        updatePaginationInfo() {
            const totalRecords = this.getAllNews.length;
            this.searchObject.totalRecords = totalRecords;
            this.searchObject.numberOfPages = Math.ceil(totalRecords / this.searchObject.pageSize);
        },       
    },
    created() {
        this.updatePaginationInfo();
    },
}
</script>

<style scoped>
.news {
    background-color:  var(--secondary-color);
    padding: 5% 7% 2% 7%;
}

.news-title {
    color: var(--main-color);
    /* margin-bottom: 2%; */
    font-size: 30px;
    font-weight: 600;
    text-decoration: none;
}

.news-title a {
    text-decoration: none;
    color: var(--main-color);
}

.news-title a:hover {
    text-decoration: none;
}

.news-article {
    border-radius: 15px;
    background-color:  var(--secondary-color);
    padding: 1%;
    width: calc((100% - 90px)/4);
    min-width: calc((100% - 90px)/4);
}

.news-article-item{
    background-color:  var(--secondary-color);
}

.container-news {
    width: 100%;
    padding: 10px 7% 2% 7%;
    display: block;
    justify-content: center;
    align-items: center;
}
.view-selector {
    margin-bottom: 20px;
}

.view-selector select {
    padding: 10px;
    font-size: 18px;
}

/* Grid View Styles */
.item-list.grid {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.news-article.grid {
    border-radius: 15px;
    background-color:  var(--secondary-color);
    padding: 1%;
    width: calc((100% - 30px) / 4);
    min-width: calc((100% - 30px) / 4);
    margin-bottom: 15px;
}


/* List View Styles */
.item-list.list {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.news-article.list {
    width: 100%;
    background-color:  var(--secondary-color);
    border-radius: 15px;
    padding: 1%;
    /* margin-bottom: 15px; */
}

.loading {
    text-align: center;
    font-size: 18px;
    padding: 20px;
}

.selectLabel{
font-size: 18px;
font-weight: 500;
color: var(--main-color);
margin-right: 10px;
}

.selectOptions{
color: var(--main-color);
margin-right: 10px;
border: none;
border-radius: 0.5rem;
background-color:  var(--secondary-color);
box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
}


@media only screen and (max-width: 1200px) {   
    .item-list.grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
    }

    .news-article.grid {
        width: 100%;
        min-width: 100%;
    }
}

@media only screen and (max-width: 768px) {
    .item-list.grid {
        display: grid;
        grid-template-columns: 1fr;
    }

    .news-article.grid {
        width: 100%;
        min-width: 100%;
    }
}

</style>
